export default {
  reviewsConfigs: {
    reviewsList: {
      81: { name: 'JiggySpot', title: 'review_8_title', rating: 5, text: 'review_8_text_tiktok' },
    },
  },
};
